import { setupPermissionDirective } from './permission.js'

export const setupDirectives = (app) => {
  setupPermissionDirective(app)
}
